import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import Select from '../Select';
import TopScrollBar from '../TopScrollBar';

const Wrapper = styled('div')`
  .bs-bars {
    button {
      margin-right: 10px;
    }
  }
  .fixed-table-toolbar {
    min-height: 60px;
  }
  table.table {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 0;
    tr {
      &.not-available {
        opacity: 0.4;
      }
    }
    td {
      vertical-align: middle;
      color: #343a40;
      .variant-input {
        width: 100px;
      }
      .table-item-title {
        font-weight: bold;
      }
    }
    th {
      .both {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC');
      }
      .asc {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==');
      }
      .desc {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII= ');
      }
      .sortable {
        cursor: pointer;
        background-position: right;
        background-repeat: no-repeat;
        padding-right: 30px;
      }
      .th-inner {
        padding-right: 20px;
        vertical-align: bottom;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .fixed-table-pagination {
    height: 50px;
  }
  .variant-toggle-span {
    font-size: 12px;
    font-style: italic;
    text-decoration: underline;
    color: #6c757d;
  }

  @media (max-width: 550px) {
    .bs-bars button {
      margin-bottom: 10px;
    }
  }
`;
const MatchingTh = (props) => {
  const { index, value = null, matchingOptions, handleUpdateMatching } = props;
  return (
    <th>
      <div style={{ minWidth: '150px' }}>
        <Select
          options={matchingOptions}
          value={matchingOptions.find((o) => o.value === value) || null}
          onChange={({ value }) => handleUpdateMatching(index, value)}
        />
      </div>
    </th>
  );
};

const HeaderTh = (props) => {
  const { title } = props;
  return <th>{title}</th>;
};

const ItemTr = (props) => {
  const { item, testid } = props;

  return (
    <tr data-testid={testid}>
      {Object.keys(item).map((key) => (
        <td>{item[key]}</td>
      ))}
    </tr>
  );
};

const PreviewFile = (props) => {
  const { importData, matchingOptions, matchingValues, setMatchingValues } = props;

  const { header = [], body = [] } = importData;

  useEffect(() => {
    const newValues = header.reduce((a, c, i) => {
      if (c.matchedId && c.matchedId !== 'undefined') {
        a[i] = c.matchedId;
      }
      return a;
    }, {});
    setMatchingValues(newValues);
  }, []);

  const handleUpdateMatching = (index, value) => {
    const newValues = { ...matchingValues, [index]: value };
    setMatchingValues(newValues);
  };

  return (
    <React.Fragment>
      <Wrapper className="bootstrap-table">
        <div className="fixed-table-container">
          <TopScrollBar>
            <div className="fixed-table-body">
              <table className="table table-centered table-sm">
                <thead className="thead-light">
                  <tr>
                    {header.map((h, i) => (
                      <MatchingTh
                        key={`matching-${i}`}
                        index={i}
                        value={matchingValues[i]}
                        matchingOptions={matchingOptions}
                        handleUpdateMatching={handleUpdateMatching}
                      />
                    ))}
                  </tr>
                </thead>

                <tbody>
                  <tr data-testid="thead">
                    {header.map((h) => (
                      <HeaderTh key={`header-${h.id}`} title={h.title} />
                    ))}
                  </tr>
                  {body.map((b, i) => (
                    <ItemTr key={`body-${i}`} item={b.rowBody} testid={`body-${i}`} />
                  ))}
                </tbody>
              </table>
            </div>
          </TopScrollBar>
        </div>
      </Wrapper>
    </React.Fragment>
  );
};
export default PreviewFile;
